import * as React from 'react'
import {Form, Col, Row, Table, Input, Tooltip, Modal, Empty} from 'antd'
import {Link} from 'react-router-dom'
import Layouts from '../components/Layouts'
import HomeInsurancePolicy from '../components/grid/HomeInsurancePolicy'
import {EyeOutlined} from '@ant-design/icons'
import {Spin} from 'antd'
import hasPermissions from '../hooks/Permissions'
import apiRequest from '../hooks/ApiRequest'
import { render } from 'sass'

const baseAddress = process.env.REACT_APP_BASE_CUST
class customer extends React.Component {
  constructor() {
    super()
    this.state = {
      customer: null,
      searchBox: null,
      gotData: false,
      visible: false,
      visibleSearch: false,
      filterTable: null,
      baseData: [],
      uni: '',
      CustPermissions: {},
      quotationPermissions: {},
      loading: false,
      productname: localStorage.getItem('productName'),
      filterTable: [],
      customerData: [],
      columns: [
        {
          key: '1',
          title: 'Customer Name',
          //dataIndex: 'client_name',
          dataIndex: 'customerName',
        },
        {
          key: '2',
          title: 'Surname',
          dataIndex: 'customerSurname',
        },
        {
          key: '3',
          title: 'Mobile',
          dataIndex: 'mobile',
        },
        {
          key: '4',
          title: 'National Id',
          dataIndex: 'nationalID',
        },
        {
          key: '5',
          title: 'Address',
          dataIndex: 'address',
            width: '28%'
          // render: (text, record) => (
          //   <p title={record.address}> </p>)       
        },
        {
          key: '6',
          title: 'Age',
          dataIndex: 'age',
        },
        {
          key: '7',
          title: 'Action',
          render: record => (
            <>
              {this.state.CustPermissions.hasOwnProperty('14') && (
                <Tooltip title="View policies">
                  <button
                    className="ant-btn edit_btn ant-btn-primary"
                    onClick={() => this.ViewPolicies(record.nationalID)}>
                    <EyeOutlined />
                  </button>
                </Tooltip>
              )}
            </>
          ),
        },
      ],
    }

    this.updateInput = this.updateInput.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.setVisible = this.setVisible.bind(this)
    this.setVisibleFalse = this.setVisibleFalse.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.setVisibleSearch = this.setVisibleSearch.bind(this)
    this.EditRecord = this.EditRecord.bind(this)
  }
  search = value => {
    const {customerData} = this.state
    // debugger
    const filterTable = customerData.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    this.setState({filterTable})
    this.getCustomer = this.getCustomer.bind(this)
  }

  componentDidMount() {
    //Api call
    // this.setState({ loading: true })
    const permissions = hasPermissions('Customers')
    const quot_permissions = hasPermissions('Quotation')

    this.setState(
      {CustPermissions: permissions, quotationPermissions: quot_permissions},
      () => {
        // console.log("Saved Customer permissions", this.state.CustPermissions);
      },
    )

    this.setState()
    // fetch(process.env.REACT_APP_BASE_URL_CLIENT + '/customer')
    //   .then(res => res.json())
    //   .then(data => {
    //     console.log(data)
    //     this.setState({
    //       baseData: data,
    //     })
    //     this.setState({ loading: false })
    //   })
    // console.log("Base Address:", process.env.REACT_APP_BASE_CUST);

    this.getCustomer()
  }

  getCustomer = async () => {
    this.setState({loading: true})
    try {
      const response = await apiRequest(
        `${baseAddress}/Customers/GetCustDetails`,
        'GET',
      )

      if (response.success) {
        this.setState({customerData: response.data})
      } else {
        console.error('API Error:', response.error)
        // message.error(response.error || "Failed to fetch customer details.");
      }
    } catch (error) {
      console.error('Request failed:', error)
      // message.error("Something went wrong. Please try again.");
    } finally {
      this.setState({loading: false})
    }
  }

  deleteRecord(val) {
    alert(val)
  }

  onhandleChange() {
    alert('sadsad')
  }

  ViewPolicies(val) {
    localStorage.setItem('nationalID', val)
    window.location.href = '/policies'
  }

  EditRecord(val) {
    this.setState({uni: val})
    this.setState({visible: true})
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        alert('asdsadsadsa')
      }
    })
  }

  // Functions for search functionality (if data not found)
  // Hide function to hide the modal after user clicked on cancel button
  hideModal() {
    this.setState({
      visibleSearch: false,
    })
  }

  // Redirecting to another model where client can add customer to the database
  setVisibleSearch() {
    this.setState({
      visibleSearch: false,
    })
    this.setState({visible: true})
  }

  // Functions for Modal functioanlity to add customers
  setVisible() {
    alert('sadsasa')
  }
  setVisibleFalse() {
    this.setState({visible: false})
  }

  // Functions for search functionality
  handleChange({target}) {
    this.setState({
      [target.name]: target.value,
    })
  }

  updateInput() {
    if (this.state.searchBox === 'Mayank') {
      alert('Data Found')
    } else {
      this.setState({
        visibleSearch: true,
      })
    }
  }

  render() {
    const {filterTable, customerData, columns} = this.state
    const dataSource =
      filterTable && filterTable.length > 0 ? filterTable : customerData
    return (
      <>
        <Layouts title="assets" classname="dashboard">
          <Spin
            className="loader-icon-fixed"
            spinning={this.state.loading}
            size="large"></Spin>
          <div className="dash-bg-white">
            <Row gutter={[16, 16]}>
              <Col xs={12} sm={24} md={24} lg={12}>
                <div className="section-top-heading">
                  <h3
                    style={{
                      color: '#0C1362',
                      fontWeight: '600',
                      fontSize: '20px',
                    }}>
                    {this.state.productname} CUSTOMERS
                  </h3>
                </div>
              </Col>
              <Col xs={12} sm={24} md={24} lg={8}>
                <div className="item-search">
                  <Form.Item>
                    <Input.Search
                      placeholder="Search ..."
                      enterButton
                      onSearch={this.search}
                    />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={12} sm={24} md={24} lg={4}>
                {this.state.quotationPermissions.hasOwnProperty('11') && (
                  <div className="create-quotation">
                    <Link to="/CreateQuotation" className="btn btn-primary">
                      Create Quotation
                    </Link>
                  </div>
                )}
              </Col>
            </Row>
          </div>
          <div className="table-grid-bx">
            <Table
              dataSource={dataSource}
              columns={columns}
              rowKey="nationalID"
              // locale={{
              //   emptyText: <Empty description="No customers found" />,
              // }}
            />
          </div>

          <Modal
            title="Add Customer"
            centered
            visible={this.state.visible}
            footer={null}
            onCancel={this.setVisibleFalse}
            width={1000}>
            <HomeInsurancePolicy parentToChild={this.state.uni} />
          </Modal>
        </Layouts>
      </>
    )
  }
}

Form.create({name: 'normal_login'})(customer)

export default customer
